import type { SanitizedCollectionConfig } from 'payload'

export type IndexProps = {
  collection: SanitizedCollectionConfig
  isEditing?: boolean
}
